// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__13rEx","label":"styles_label__jUQiE"};